import { useResponsive } from 'ahooks'
import { useMemo } from 'react'
import { CmsImage } from 'src/types'
import Image from 'src/components/atoms/Image/Image'

type FooterImageProps = {
    footerImages: CmsImage
    footerImagesMobile: CmsImage
}

export default function FooterImage({ footerImages, footerImagesMobile }: FooterImageProps) {
    const responsiveInfo = useResponsive()
    const footerImage = useMemo(() => {
        if (responsiveInfo.md) {
            return footerImages
        }
        return footerImagesMobile
    }, [footerImages, footerImagesMobile, responsiveInfo])

    const imageLink = useMemo(() => {
        //Link Url format: https://www.example.com or http://www.example.com
        const linkUrl = footerImage?.description?.match(/(https?:\/\/[^\s]+)/g)
        return linkUrl ? linkUrl[0] : false
    }, [footerImage])

    if (!footerImage) {
        return null
    }

    if (imageLink) {
        return (
            <a href={imageLink} target="_blank" rel="noopener noreferrer">
                <Image src={footerImage?.url} />
            </a>
        )
    }

    return <Image src={footerImage?.url} />
}
